"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointSecretOut = void 0;
class EndpointSecretOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointSecretOut.attributeTypeMap;
    }
}
exports.EndpointSecretOut = EndpointSecretOut;
EndpointSecretOut.discriminator = undefined;
EndpointSecretOut.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EndpointSecretOut.js.map